.diagram {
  display: flex;
  align-items: stretch;
  gap: var(--tuna-spacing-2);
}
.block {
  flex: 1;
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  padding: var(--tuna-spacing-3);
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  transition:
    background-color 200ms,
    border-color 200ms;
}
.block[data-active='true'] {
  border-color: var(--tuna-palette-primary-main);
  background-color: var(--tuna-feedback-info-bg);
}
.label {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
  text-transform: uppercase;
}
.keyName {
  font-size: var(--tuna-typography-h4-fontSize);
  font-weight: 600;
}
.chords {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}
.arrow {
  display: flex;
  align-items: center;
  font-size: var(--tuna-typography-h3-fontSize);
  color: var(--tuna-content-secondary);
}
